import {DeviceParamGatewayV3FindBleLiris} from "./device-param-gateway-v3-find-ble-liris";

export class DeviceParamGatewayV3OsmosLirisManager {
    public find_ble_liris: DeviceParamGatewayV3FindBleLiris = new DeviceParamGatewayV3FindBleLiris();
    public display: {trame: number} =  {trame: 1};
    public post_data: {nb_items: number} = {nb_items: 1000};

}
